import ActionTypes from '../constants/ActionTypes';

const initialState = {
  electricity: [],
  water: [],
  gas: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.INVOICES_ELECTRICITY_FETCH_SUCCEEDED:
      return {
        ...state,
        electricity: payload.data.invoices,
      };
    case ActionTypes.INVOICES_WATER_FETCH_SUCCEEDED:
      return {
        ...state,
        water: payload.data.invoices,
      };
    case ActionTypes.INVOICES_GAS_FETCH_SUCCEEDED:
      return {
        ...state,
        gas: payload.data.invoices,
      };
    default:
      return state;
  }
};
